// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import request from '@/utils/request';

/**
 * 获取卡片交易明细列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function getCardDetailList(params) {
  return request({
    url: '/admin/card/transaction/list',
    method: 'get',
    params: params
  });
}

/**
 * 获取卡片交易详情
 * @param {string|number} id 交易ID
 * @returns {Promise}
 */
export function getCardDetailById(id) {
  return request({
    url: "/admin/card/transaction/detail/".concat(id),
    method: 'get'
  });
}

/**
 * 导出福卡明细
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function exportCardDetail(params) {
  return request({
    url: '/admin/fudou/card/record/card/export',
    method: 'get',
    params: params
  });
}

/**
 * 导出收支明细
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function exportTransactionDetail(params) {
  return request({
    url: '/admin/fudou/card/record/log/export',
    method: 'get',
    params: params
  });
}

// 保留原有函数名以保持兼容性
export var exportCardTransactions = exportTransactionDetail;

/**
 * 获取卡片交易类型下拉选项
 * @returns {Promise}
 */
export function getTransactionTypes() {
  return request({
    url: '/admin/card/transaction/types',
    method: 'get'
  });
}

/**
 * 获取卡片详情
 * @param {string|number} empIntegralId - 卡片ID
 */
export function getCardDetail(empIntegralId) {
  return request({
    url: '/admin/fudou/card/record/card/detail',
    method: 'get',
    params: {
      id: empIntegralId
    }
  });
}

/**
 * 获取卡片收支明细列表
 * @param {Object} params - 查询参数，包含cardId、page、limit等
 */
export function getCardTransactions(params) {
  return request({
    url: '/admin/fudou/card/record/log/index',
    method: 'get',
    params: params
  });
}

/**
 * 获取客户列表
 * @param {Object} params - 查询参数，包含page、limit、keyword
 */
export function getCustomerList(params) {
  return request({
    url: '/admin/customer/select',
    method: 'get',
    params: params
  });
}

/**
 * 获取小程序列表
 * @param {Object} params - 查询参数，包含page、limit、keyword
 */
export function getMiniappList(params) {
  return request({
    url: '/admin/companyapp/autoList',
    method: 'get',
    params: params || {
      keyword: ''
    }
  });
}

/**
 * 获取项目列表
 * @param {Object} params - 查询参数，包含page、limit、keyword
 */
export function getProjectList(params) {
  return request({
    url: '/admin/fudou/project/select',
    method: 'get',
    params: params
  });
}

/**
 * 修改福卡绑定手机号
 */
export function updateCardPhone(data) {
  return request({
    url: '/admin/welfare/card/update/phone',
    method: 'POST',
    data: data
  });
}

/**
 * 获取福卡列表
 */
export function getCardList(params) {
  return request({
    url: '/admin/fudou/card/record/card/index',
    method: 'get',
    params: params
  });
}